import "./Schedule.module.css";
import Header from "@/reusable_sections/Header";
import AgendaOverview from "./sections/AgendaOverview";
import DownloadSchedule from "./sections/DownloadSchedule";
import Footer from "@/reusable_sections/Footer";
export default function SchedulePage() {
  return <div>
      <Header />
      <AgendaOverview />
      <DownloadSchedule />
      <Footer />
    </div>;
}